import { useTranslation } from '@lyearn/i18n';
import { Checkbox, Stack, Typography } from '@lyearn/ui';

import { SelectAllProps } from '../types';

const SelectAll = ({ state, onSelectAllClick }: SelectAllProps) => {
  const { t } = useTranslation();

  return (
    <Stack
      alignItems="center"
      className="mx-8 mb-2 flex h-38 items-center px-12"
      justifyContent="between"
      onClick={() => {
        onSelectAllClick(state === 'some' || state === 'none' ? 'all' : 'none');
      }}>
      <Typography as="p" className="" color="text-text-placeholder" variant="label-caps">
        {t('Common:Filter.SelectAll')}
      </Typography>
      <Checkbox
        parent
        checked={state === 'some' ? undefined : state === 'all'}
        indeterminate={state === 'some'}
      />
    </Stack>
  );
};

export default SelectAll;
